import type {
  AccessorialScheduleChargeOption,
  AddedAccessorialScheduleChargeOption,
} from "../../hooks/react-query/backOffice/useAccessorialScheduleForm";

export const mockAccessorialScheduleChargeOptions: AccessorialScheduleChargeOption[] =
  [
    {
      id: 1,
      description: "LFT (Liftgate) - Liftgate required",
    },
    {
      id: 2,
      description: "RES (Residential) - Residential delivery",
    },
    {
      id: 3,
      description: "INS (Inside Delivery) - Inside delivery",
    },
    {
      id: 4,
      description: "APT (Appointment) - Appointment required",
    },
    {
      id: 5,
      description: "LTD (Limited Access) - Limited access location",
    },
    {
      id: 6,
      description: "CON (Construction Site) - Construction site delivery",
    },
  ];

export const mockAddedAccessorialScheduleChargeOptions: AddedAccessorialScheduleChargeOption[] =
  [
    {
      id: 1,
      code: "LFT",
      description: "LFT (Liftgate) - Liftgate required",
      rateConfiguration: "Flat Rate",
      rateMinMax: "$1.699",
      appliesTo: "Both",
      status: "Active",
      autoAssign: "No",
    },
    {
      id: 2,
      code: "RES",
      description: "RES (Residential) - Residential delivery",
      rateConfiguration: "Flat Rate",
      rateMinMax: "$1.699",
      appliesTo: "Both",
      status: "Active",
      autoAssign: "Yes",
    },
    {
      id: 3,
      code: "INS",
      description: "INS (Inside Delivery) - Inside delivery",
      rateConfiguration: "Flat Rate",
      rateMinMax: "$1.699",
      appliesTo: "Delivery",
      status: "Active",
      autoAssign: "No",
    },
    {
      id: 4,
      code: "APT",
      description: "APT (Appointment) - Appointment required",
      rateConfiguration: "Rate per Unit",
      rateMinMax: "$1.699 ($1.699, $1.699)",
      appliesTo: "Pickup",
      status: "Active",
      autoAssign: "Yes",
    },
    {
      id: 5,
      code: "LTD",
      description: "LTD (Limited Access) - Limited access location",
      rateConfiguration: "Flat Rate",
      rateMinMax: "$2.50",
      appliesTo: "Both",
      status: "Draft",
      autoAssign: "No",
    },
    {
      id: 6,
      code: "CON",
      description: "CON (Construction Site) - Construction site delivery",
      rateConfiguration: "Percentage",
      rateMinMax: "15% (3.49%, $5,699)",
      appliesTo: "Pickup",
      status: "Active",
      autoAssign: "Yes",
    },
  ];
